/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupDetails
 */
export interface UserGroupDetails {
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetails
     */
    userEmployeeId: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetails
     */
    userLastName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetails
     */
    userFirstName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetails
     */
    userJobTitle: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetails
     */
    userFleetRole: boolean;
}

/**
 * Check if a given object implements the UserGroupDetails interface.
 */
export function instanceOfUserGroupDetails(value: object): value is UserGroupDetails {
    if (!('userEmployeeId' in value) || value['userEmployeeId'] === undefined) return false;
    if (!('userLastName' in value) || value['userLastName'] === undefined) return false;
    if (!('userFirstName' in value) || value['userFirstName'] === undefined) return false;
    if (!('userJobTitle' in value) || value['userJobTitle'] === undefined) return false;
    if (!('userFleetRole' in value) || value['userFleetRole'] === undefined) return false;
    return true;
}

export function UserGroupDetailsFromJSON(json: any): UserGroupDetails {
    return UserGroupDetailsFromJSONTyped(json, false);
}

export function UserGroupDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'userEmployeeId': json['userEmployeeId'],
        'userLastName': json['userLastName'],
        'userFirstName': json['userFirstName'],
        'userJobTitle': json['userJobTitle'],
        'userFleetRole': json['userFleetRole'],
    };
}

export function UserGroupDetailsToJSON(json: any): UserGroupDetails {
    return UserGroupDetailsToJSONTyped(json, false);
}

export function UserGroupDetailsToJSONTyped(value?: UserGroupDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userEmployeeId': value['userEmployeeId'],
        'userLastName': value['userLastName'],
        'userFirstName': value['userFirstName'],
        'userJobTitle': value['userJobTitle'],
        'userFleetRole': value['userFleetRole'],
    };
}

